<template>
  <div class="article-sidebar-filters">
    <div class="filter-card">
      <ArticleCategoriesFilter
          :categories="filters.rubrics.options"
          :initial-rubric-id="initialRubricId"
          :show-title="showTitles"
          @on-change="(v) => $emit('on-change', v)"
      />
    </div>
    <div class="filter-card">
      <ArticleTagsFilter
          :tags="filters.tags.options"
          :popular-tags="filters.popular_tags.options"
          :initial-tag-ids="initialTagIds"
          @on-change="(v) => $emit('on-change', v)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ArticleFilters } from '~/models/articles'
import ArticleCategoriesFilter from './ArticleCategoriesFilter.vue'
import ArticleTagsFilter from './ArticleTagsFilter.vue'

defineProps<{
  filters: ArticleFilters
  initialRubricId?: string
  initialTagIds?: string
  showTitles?: boolean
}>()

defineEmits<{
  (e: 'on-change', value: Record<string, string | undefined>): void
}>()
</script>

<style lang="scss" scoped>
.article-sidebar-filters {
  @extend %flex-column;

  gap: 16px;

  > .filter-card {
    background: $color-default-white;
    border-radius: 20px;
    padding: 24px 20px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 4%);
  }
}
</style>
